import { render, staticRenderFns } from "./EditPersonalInfo2.vue?vue&type=template&id=f559da2a&scoped=true"
import script from "./EditPersonalInfo2.vue?vue&type=script&lang=js"
export * from "./EditPersonalInfo2.vue?vue&type=script&lang=js"
import style0 from "./EditPersonalInfo2.vue?vue&type=style&index=0&id=f559da2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f559da2a",
  null
  
)

export default component.exports